export enum BidReductionTab {
  modelDashboard = 'model-dashboard',
  configs = 'configs',
}
